'use client';

import React from 'react';
import createSvgIcon from '@almacareer/profesiaui/components/common/icons/createNewIcon';

const Telescope = createSvgIcon(
    <g id="Group_17153" data-name="Group 17153" transform="translate(-1007 -432.79)">
        <g id="Group_17152" data-name="Group 17152" transform="translate(972.378 178.465)">
            <path
                id="Path_11281"
                data-name="Path 11281"
                d="M1477.662,806.505s2.02,33.646-.552,34.923-19.607-26.689-25-20.3,5.111,48.2,31.232,53.2,22.572-37.226,18.171-45.925S1477.662,806.505,1477.662,806.505Z"
                transform="translate(-1114.534 -434.586)"
                fill="#c88e7e"
            />
            <g id="Group_17144" data-name="Group 17144" transform="translate(34.622 254.326)">
                <g id="Group_17127" data-name="Group 17127" transform="translate(128.875 26.711)">
                    <g
                        id="Group_17125"
                        data-name="Group 17125"
                        transform="translate(26.922 34.028)"
                    >
                        <rect
                            id="Rectangle_2612"
                            data-name="Rectangle 2612"
                            width="19.187"
                            height="7.554"
                            transform="translate(0 13.408) rotate(-44.333)"
                            fill="#2f2b66"
                        />
                    </g>
                    <g id="Group_17126" data-name="Group 17126" transform="translate(0)">
                        <rect
                            id="Rectangle_2613"
                            data-name="Rectangle 2613"
                            width="35.054"
                            height="8.118"
                            transform="translate(84.705 55.039) rotate(-152.564)"
                            fill="#311e69"
                        />
                        <path
                            id="Path_11282"
                            data-name="Path 11282"
                            d="M653.961,403.731l70.856,36.784a1,1,0,0,0,1.353-.429l7.7-14.833a1,1,0,0,0-.429-1.353l-70.856-36.784Z"
                            transform="translate(-650.94 -385.548)"
                            fill="#dfebf1"
                        />
                        <path
                            id="Path_11283"
                            data-name="Path 11283"
                            d="M716.879,453.494c6.429,3.012,10.721,4.729,13.082,5.609l-2.727,5.253a3.313,3.313,0,0,1-4.467,1.414l-68.806-35.72,4.928-9.493c4.52,3.007,9.494,6.28,14.549,9.541A348.529,348.529,0,0,0,716.879,453.494Z"
                            transform="translate(-650.94 -411.868)"
                            fill="#bdcbd0"
                        />
                        <rect
                            id="Rectangle_2614"
                            data-name="Rectangle 2614"
                            width="22.678"
                            height="18.72"
                            transform="translate(20.127 27.064) rotate(-152.564)"
                            fill="#2f2b66"
                        />
                        <rect
                            id="Rectangle_2615"
                            data-name="Rectangle 2615"
                            width="14.763"
                            height="23.259"
                            rx="3.865"
                            transform="matrix(-0.888, -0.461, 0.461, -0.888, 47.676, 43.922)"
                            fill="#2f2b66"
                        />
                        <rect
                            id="Rectangle_2616"
                            data-name="Rectangle 2616"
                            width="5.629"
                            height="13.414"
                            rx="2.721"
                            transform="translate(84.954 58.41) rotate(-152.566)"
                            fill="#2f2b66"
                        />
                    </g>
                </g>
                <g id="Group_17128" data-name="Group 17128" transform="translate(158.255 322.578)">
                    <path
                        id="Path_11284"
                        data-name="Path 11284"
                        d="M781.51,1789.816a3.8,3.8,0,0,0,.726-.07l67.9-13.218a3.777,3.777,0,1,0-1.444-7.414l-67.9,13.218a3.777,3.777,0,0,0,.718,7.484Z"
                        transform="translate(-777.736 -1769.043)"
                        fill="#2f2b66"
                    />
                </g>
                <g id="Group_17129" data-name="Group 17129" transform="translate(90.355 322.578)">
                    <path
                        id="Path_11285"
                        data-name="Path 11285"
                        d="M530.582,1789.815a3.777,3.777,0,0,0,.718-7.485l-67.9-13.218a3.777,3.777,0,1,0-1.444,7.414l67.9,13.218A3.789,3.789,0,0,0,530.582,1789.815Z"
                        transform="translate(-458.9 -1769.042)"
                        fill="#2f2b66"
                    />
                </g>
                <g id="Group_17132" data-name="Group 17132" transform="translate(167.233 140.194)">
                    <g
                        id="Group_17130"
                        data-name="Group 17130"
                        transform="translate(62.439 210.66)"
                    >
                        <path
                            id="Path_11286"
                            data-name="Path 11286"
                            d="M1126.773,1907.647a6.137,6.137,0,1,1-11.749,3.551l-1.94-6.419,11.927-2.958Z"
                            transform="translate(-1113.085 -1901.821)"
                            fill="#2f2b66"
                        />
                    </g>
                    <g id="Group_17131" data-name="Group 17131">
                        <path
                            id="Path_11287"
                            data-name="Path 11287"
                            d="M824.253,912.895a6.135,6.135,0,0,1,7.65,4.1l62.354,206.3-11.927,2.958-62.175-205.7A6.137,6.137,0,0,1,824.253,912.895Z"
                            transform="translate(-819.89 -912.63)"
                            fill="#dfebf1"
                        />
                    </g>
                </g>
                <g id="Group_17135" data-name="Group 17135" transform="translate(155.896 142.404)">
                    <g id="Group_17133" data-name="Group 17133">
                        <path
                            id="Path_11288"
                            data-name="Path 11288"
                            d="M772.794,923.008a6.137,6.137,0,0,1,6.137,6.137v206.768H766.657V929.145A6.137,6.137,0,0,1,772.794,923.008Z"
                            transform="translate(-766.657 -923.008)"
                            fill="#dfebf1"
                        />
                    </g>
                    <g id="Group_17134" data-name="Group 17134" transform="translate(0 212.905)">
                        <path
                            id="Path_11289"
                            data-name="Path 11289"
                            d="M778.931,1925.884a6.137,6.137,0,1,1-12.274,0v-3.147h12.274Z"
                            transform="translate(-766.657 -1922.737)"
                            fill="#2f2b66"
                        />
                    </g>
                </g>
                <g id="Group_17138" data-name="Group 17138" transform="translate(78.475 140.195)">
                    <g id="Group_17136" data-name="Group 17136" transform="translate(1.894)">
                        <path
                            id="Path_11290"
                            data-name="Path 11290"
                            d="M477.22,916.928a6.137,6.137,0,1,1,11.706,3.688L424.07,1126.5l-12.062-2.558Z"
                            transform="translate(-412.008 -912.634)"
                            fill="#dfebf1"
                        />
                    </g>
                    <g id="Group_17137" data-name="Group 17137" transform="translate(0 211.31)">
                        <path
                            id="Path_11291"
                            data-name="Path 11291"
                            d="M405.007,1904.874l12.062,2.558-1.965,6.237a6.137,6.137,0,1,1-11.706-3.688Z"
                            transform="translate(-403.113 -1904.874)"
                            fill="#2f2b66"
                        />
                    </g>
                </g>
                <path
                    id="Path_11292"
                    data-name="Path 11292"
                    d="M736.421,879.741h-7.067a2.717,2.717,0,0,0-2.717,2.717v.079a2.717,2.717,0,0,1-2.717,2.717H709.527a2.717,2.717,0,0,1-2.717-2.717h0a2.717,2.717,0,0,0-2.717-2.717h-4.019a2.721,2.721,0,0,1-2.713-2.9c.311-5.039,2.471-15.045,14.563-16.771,16.223-2.316,24.035,5.372,27.118,16.136A2.72,2.72,0,0,1,736.421,879.741Z"
                    transform="translate(-556.219 -730.807)"
                    fill="#2f2b66"
                />
                <path
                    id="Path_11293"
                    data-name="Path 11293"
                    d="M76.257,328.683l165.277,78.9,12.854.8,13.771-27.593-8.044-10.942L97.9,285.318Z"
                    transform="translate(-67.39 -278.718)"
                    fill="#dfebf1"
                />
                <g id="Group_17139" data-name="Group 17139" transform="translate(8.867 31.028)">
                    <path
                        id="Path_11294"
                        data-name="Path 11294"
                        d="M258.047,491.332l-3.659,7.332-12.854-.8L76.257,418.96l9.451-18.938Z"
                        transform="translate(-76.257 -400.022)"
                        fill="#bdcbd0"
                    />
                </g>
                <path
                    id="Path_11295"
                    data-name="Path 11295"
                    d="M36.878,305.661l60.356,25.871L119.21,287.5,62.252,254.82a3.722,3.722,0,0,0-5.183,1.567L35.014,300.578A3.722,3.722,0,0,0,36.878,305.661Z"
                    transform="translate(-34.622 -254.326)"
                    fill="#2f2b66"
                />
                <path
                    id="Path_11296"
                    data-name="Path 11296"
                    d="M926.473,733.644l69.976,35.921L985.862,791.8,912.7,761.237Z"
                    transform="translate(-725.704 -631.567)"
                    fill="#2f2b66"
                />
                <g id="Group_17140" data-name="Group 17140" transform="translate(164.182 86.078)">
                    <path
                        id="Path_11297"
                        data-name="Path 11297"
                        d="M878.969,693.206,865.2,720.8l-12.854-.8,18.581-37.735Z"
                        transform="translate(-842.381 -677.207)"
                        fill="#1d133f"
                    />
                    <path
                        id="Path_11298"
                        data-name="Path 11298"
                        d="M824.4,658.517l9.7,5.057L815.526,701.31l-9.962-4.756Z"
                        transform="translate(-805.563 -658.517)"
                        fill="#2f2b66"
                    />
                </g>
                <g id="Group_17141" data-name="Group 17141" transform="translate(276.569 109.806)">
                    <path
                        id="Path_11299"
                        data-name="Path 11299"
                        d="M1347.28,807.392l15.155-26.9a5.246,5.246,0,0,0-2-7.146l-4.842-2.728a5.247,5.247,0,0,0-7.146,2l-15.155,26.9Z"
                        transform="translate(-1333.296 -769.939)"
                        fill="#2f2b66"
                    />
                </g>
                <path
                    id="Path_11300"
                    data-name="Path 11300"
                    d="M675.831,785.5h0a4.328,4.328,0,0,1-3.735.391h0a4.328,4.328,0,0,0-5.758,3.556h0a4.327,4.327,0,0,1-2.023,3.164h0a4.328,4.328,0,0,0-.81,6.719h0a4.328,4.328,0,0,1,1.213,3.555h0a4.328,4.328,0,0,0,4.748,4.823h0A4.328,4.328,0,0,1,673,808.976h0a4.328,4.328,0,0,0,6.731-.705h0a4.328,4.328,0,0,1,3.2-1.973h0a4.328,4.328,0,0,0,3.645-5.7h0a4.328,4.328,0,0,1,.45-3.729h0a4.328,4.328,0,0,0-2.185-6.405h0a4.328,4.328,0,0,1-2.635-2.676h0A4.328,4.328,0,0,0,675.831,785.5Z"
                    transform="translate(-528.596 -671.87)"
                    fill="#2f2b66"
                />
                <path
                    id="Path_11301"
                    data-name="Path 11301"
                    d="M706.266,821.2h0a1.571,1.571,0,0,1-1.356.142h0a1.571,1.571,0,0,0-2.091,1.291h0a1.572,1.572,0,0,1-.735,1.149h0a1.572,1.572,0,0,0-.294,2.44h0a1.572,1.572,0,0,1,.44,1.291h0a1.572,1.572,0,0,0,1.724,1.751h0a1.572,1.572,0,0,1,1.284.46h0a1.572,1.572,0,0,0,2.444-.256h0a1.572,1.572,0,0,1,1.161-.717h0a1.572,1.572,0,0,0,1.324-2.07h0a1.571,1.571,0,0,1,.163-1.354h0a1.571,1.571,0,0,0-.793-2.326h0a1.572,1.572,0,0,1-.957-.972h0A1.572,1.572,0,0,0,706.266,821.2Z"
                    transform="translate(-559.353 -700.293)"
                    fill="#5f5ba5"
                />
                <g id="Group_17142" data-name="Group 17142" transform="translate(0 26.286)">
                    <path
                        id="Path_11302"
                        data-name="Path 11302"
                        d="M44.979,377.757c4.912,1.948,10.377,4.1,16.257,6.385,24.22,9.417,13.922,11.089,26.42,16.853a79.634,79.634,0,0,0,20.426,5.946L97.234,428.677,36.878,402.807a3.722,3.722,0,0,1-1.864-5.083Z"
                        transform="translate(-34.622 -377.757)"
                        fill="#1d133f"
                    />
                </g>
                <g id="Group_17143" data-name="Group 17143" transform="translate(186.998 118.933)">
                    <path
                        id="Path_11303"
                        data-name="Path 11303"
                        d="M990.575,844.2l-4.713,9.9L912.7,823.531l5.359-10.737Z"
                        transform="translate(-912.701 -812.794)"
                        fill="#1d133f"
                    />
                </g>
                <path
                    id="Path_11304"
                    data-name="Path 11304"
                    d="M1347.28,807.4l-13.984-7.878,15.156-26.9a5.244,5.244,0,0,1,6.743-2.2c-2.155,5.428-5.217,14.13-4.544,18.273a13.33,13.33,0,0,0,3.386,6.711Z"
                    transform="translate(-1056.727 -660.144)"
                    fill="#1e1240"
                />
                <path
                    id="Path_11305"
                    data-name="Path 11305"
                    d="M1251.936,878.193a3.205,3.205,0,0,0-4.439,1.307l-1.39,2.682-10.587,22.239-2.22,4.369a3.2,3.2,0,0,0,4.052,4.426l38.364-15.414a3.205,3.205,0,0,0,.4-5.755Z"
                    transform="translate(-977.745 -744.999)"
                    fill="#2f2b66"
                />
            </g>
            <g id="Group_17146" data-name="Group 17146" transform="translate(371.99 595.087)">
                <path
                    id="Path_11306"
                    data-name="Path 11306"
                    d="M1653.229,1869.525c-2.279-3.392-.224-8.1.438-12.12l-16.159-2.978s.312,9.585-1.611,12.617c-.838,1.322-16.87,9.053-17.1,10.867-.391,3.022,30.888,3.059,36.1.152C1657.614,1876.543,1655.727,1873.244,1653.229,1869.525Z"
                    transform="translate(-1618.789 -1854.428)"
                    fill="#f5c6b7"
                />
                <g id="Group_17145" data-name="Group 17145" transform="translate(0 13.583)">
                    <path
                        id="Path_11307"
                        data-name="Path 11307"
                        d="M1652.55,1918.338c-3.423.308-6.591,2.747-12.037,3.055-4.66.264-5.722-1.716-5.884-3.183-3.96,2.51-15.636,8.354-15.836,9.9-.391,3.022,30.888,3.059,36.1.152,2.725-1.521.838-4.819-1.661-8.538A5.783,5.783,0,0,1,1652.55,1918.338Z"
                        transform="translate(-1618.789 -1918.21)"
                        fill="#050608"
                    />
                </g>
            </g>
            <g id="Group_17148" data-name="Group 17148" transform="translate(410.275 595.087)">
                <path
                    id="Path_11308"
                    data-name="Path 11308"
                    d="M1833,1869.525c-2.279-3.392-.224-8.1.438-12.12l-16.159-2.978s.312,9.585-1.611,12.617c-.838,1.322-16.87,9.053-17.1,10.867-.391,3.022,30.888,3.059,36.1.152C1837.389,1876.543,1835.5,1873.244,1833,1869.525Z"
                    transform="translate(-1798.564 -1854.428)"
                    fill="#f5c6b7"
                />
                <g id="Group_17147" data-name="Group 17147" transform="translate(0 13.583)">
                    <path
                        id="Path_11309"
                        data-name="Path 11309"
                        d="M1832.325,1918.338c-3.423.308-6.591,2.747-12.037,3.055-4.66.264-5.722-1.716-5.884-3.183-3.96,2.51-15.637,8.354-15.836,9.9-.391,3.022,30.888,3.059,36.1.152,2.725-1.521.838-4.819-1.661-8.538A5.779,5.779,0,0,1,1832.325,1918.338Z"
                        transform="translate(-1798.564 -1918.21)"
                        fill="#050608"
                    />
                </g>
            </g>
            <path
                id="Path_11310"
                data-name="Path 11310"
                d="M1613.284,1051.594s-14.176,52.969-19.059,74.187c-5.263,22.868,13.267,93.544,25.842,97.419,11.6,3.574,13.88,7.959,18.9,5.221,10.019-5.472-10.051-65.919-9.448-84.916.375-11.779,23.976-85.857,19.255-94.879S1613.284,1051.594,1613.284,1051.594Z"
                transform="translate(-1226.744 -622.498)"
                fill="#311e69"
            />
            <path
                id="Path_11311"
                data-name="Path 11311"
                d="M1613.284,1051.594s-14.176,52.969-19.059,74.187c-5.263,22.868,13.267,93.544,25.842,97.419,11.6,3.574,13.88,7.959,18.9,5.221,10.019-5.472-10.051-65.919-9.448-84.916.375-11.779,23.976-85.857,19.255-94.879S1613.284,1051.594,1613.284,1051.594Z"
                transform="translate(-1226.744 -622.498)"
                fill="#311e69"
            />
            <g id="Group_17149" data-name="Group 17149" transform="translate(363.128 371.919)">
                <path
                    id="Path_11312"
                    data-name="Path 11312"
                    d="M1577.177,806.505s19.449,13.2,23.85,21.9c1.108,2.19,2.16,6.506,2.7,11.657a60.667,60.667,0,0,1-25.869-6.136C1578.206,823.651,1577.177,806.505,1577.177,806.505Z"
                    transform="translate(-1577.177 -806.505)"
                    fill="#5587ba"
                />
            </g>
            <path
                id="Path_11313"
                data-name="Path 11313"
                d="M1795.717,1126.416c-2.579-24.8,16.777-86.641-4.187-96.222s-38.4,10.391-38.4,10.391.386,75.348,5.164,100.728c3.475,18.46,18.431,67.367,19.061,68.806,2.35,5.369,24.962,9.661,23.96,5.293-.273-1.19,1.331-34.5-1.126-59.426C1799,1143.864,1796.418,1133.159,1795.717,1126.416Z"
                transform="translate(-1352.535 -608.59)"
                fill="#311e69"
            />
            <path
                id="Path_11314"
                data-name="Path 11314"
                d="M1788.039,1218.8c-4.758-1.316-9.139-3.337-10.1-5.542-.63-1.439-15.586-50.345-19.061-68.806-3.516-18.674-4.652-64.37-5.008-87.229,2.764-9.172,6.276-16.962,10.3-21.791a36.218,36.218,0,0,1,9.421-3.851c.452,9.917,3.143,72.2-.064,82.39-3.486,11.073,9.291,73.1,10.853,82.972C1785.368,1203.186,1787.768,1211.972,1788.039,1218.8Z"
                transform="translate(-1353.11 -611.728)"
                fill="#1e1240"
            />
            <path
                id="Path_11315"
                data-name="Path 11315"
                d="M1594.224,1133.4c4.884-21.218,19.059-74.187,19.059-74.187a130.28,130.28,0,0,1,13.492-4.269c.2,13.938-.3,30-3.164,38.058-5.678,15.98-17.414,36.991-17.6,45.7s21.553,60.193,20.809,76.093c-.351,7.485.143,13.783-.276,18.443a58.725,58.725,0,0,0-6.474-2.417C1607.491,1226.945,1588.961,1156.268,1594.224,1133.4Z"
                transform="translate(-1226.743 -630.118)"
                fill="#1e1240"
            />
            <path
                id="Path_11316"
                data-name="Path 11316"
                d="M1663.37,773.611c5.526-24.785-8.014-100.005-38.462-104.982-16.638-2.72-57,11.841-49.358,36.666,5.073,16.476,12.658,18.516,16.452,25.459,2.315,4.237,1.815,25.87,2.32,31.205.934,9.862,19.746,16.281,29.518,17.906C1648.488,783.964,1661.154,783.548,1663.37,773.611Z"
                transform="translate(-1212.019 -325.817)"
                fill="#79b3d1"
            />
            <path
                id="Path_11317"
                data-name="Path 11317"
                d="M1589.933,710.779c.068,5.455.636,13.685,3.146,19.629,4.075,9.654,21.482,56.355,19.7,68.993a77.852,77.852,0,0,1-2.223,10.152c-8.016-3.144-15.644-7.975-16.23-14.164-.505-5.334,0-26.968-2.32-31.2-3.794-6.943-11.38-8.983-16.452-25.459C1571.869,726.76,1579.345,717.19,1589.933,710.779Z"
                transform="translate(-1212.022 -359.246)"
                fill="#5587ba"
            />
            <g id="Group_17150" data-name="Group 17150" transform="translate(365.98 328.149)">
                <path
                    id="Path_11318"
                    data-name="Path 11318"
                    d="M1594.714,614.751s-4.206-1.544-4.145-5.139,3.085-9.108,7.354-8.6,5.143,3.378,5.143,3.378a5.334,5.334,0,0,1,4.473,2.156c1.744,2.388,3.391,8.991,3.391,8.991S1598.1,618.519,1594.714,614.751Z"
                    transform="translate(-1590.568 -600.975)"
                    fill="#050608"
                />
                <path
                    id="Path_11319"
                    data-name="Path 11319"
                    d="M1662.852,654.629l5.506,4.54c4.791,3.95,4.581,6.357-.215,10.3-.731.6-5.086,3.051-5.213,2.25l-1.565-12.41Z"
                    transform="translate(-1646.289 -643.203)"
                    fill="#f5c6b7"
                />
                <path
                    id="Path_11320"
                    data-name="Path 11320"
                    d="M1616.756,638.873l6.74,4.973a5.109,5.109,0,0,1,.608,7.1,14.117,14.117,0,0,1-4.946,3.827c-2.013,1.1-4.23-.006-5.96-2.436a27.843,27.843,0,0,1-3.934-8.621C1608.078,639.317,1612.126,635.954,1616.756,638.873Z"
                    transform="translate(-1605.118 -629.94)"
                    fill="#f5c6b7"
                />
                <path
                    id="Path_11321"
                    data-name="Path 11321"
                    d="M1632.092,644.952l-6.74-4.973a7.592,7.592,0,0,0-1.664-.8c1.023,1.232,3.03,4.027,3.014,4.752-.041,1.859-.765.694-2.989,2.178a16.294,16.294,0,0,0-3.737,4.272,23.206,23.206,0,0,0,1.818,3.058c1.73,2.429,3.947,3.531,5.96,2.436a14.117,14.117,0,0,0,4.946-3.827A5.109,5.109,0,0,0,1632.092,644.952Z"
                    transform="translate(-1613.713 -631.046)"
                    fill="#050608"
                />
                <path
                    id="Path_11322"
                    data-name="Path 11322"
                    d="M1629.4,678.089a13.766,13.766,0,0,1-3.621,2.746s.947,1.454,2.152,1.335S1630.084,680.139,1629.4,678.089Z"
                    transform="translate(-1618.278 -661.667)"
                    fill="#fff"
                />
                <path
                    id="Path_11323"
                    data-name="Path 11323"
                    d="M1640.331,674.794c1.778-1.892,5.59.128,7.157-5.474.293-1.045-.294-2.637-.674-3.561l.147.109a5.109,5.109,0,0,1,.608,7.1,14.118,14.118,0,0,1-4.946,3.827,3.558,3.558,0,0,1-3.754-.254C1639.281,676.337,1639.788,675.372,1640.331,674.794Z"
                    transform="translate(-1628.583 -651.963)"
                    fill="#050608"
                />
                <path
                    id="Path_11324"
                    data-name="Path 11324"
                    d="M1647.934,641.926a7.328,7.328,0,0,0-.78-1.34c-.571-.8-1.234-2.132.376-2.393,2.342-.38,5.146,3.51,3.39,5.249C1649.616,644.733,1648.45,643.127,1647.934,641.926Z"
                    transform="translate(-1634.604 -630.247)"
                    fill="#f5c6b7"
                />
            </g>
            <path
                id="Path_11325"
                data-name="Path 11325"
                d="M1475.758,679.244c-16.132-1.721-20.458,58.666-27.778,62.28-9.584,4.732-59.086-34.389-64.733-27.068-10.792,13.992,47.647,70.163,79.119,58.111C1493.342,760.7,1497.63,681.577,1475.758,679.244Z"
                transform="translate(-1060.387 -334.398)"
                fill="#f5c6b7"
            />
            <path
                id="Path_11326"
                data-name="Path 11326"
                d="M1367.993,823.267s-8.393-7.189-14.392-7.818a3.572,3.572,0,0,0-3.416,1.85,7.6,7.6,0,0,0-.359,7.589c.685,1.354,2.082-1.42,2.082-1.42s4.142,5.962,8.518,6.246S1367.993,823.267,1367.993,823.267Z"
                transform="translate(-1034.446 -441.612)"
                fill="#f5c6b7"
            />
            <g id="Group_17151" data-name="Group 17151" transform="translate(393.934 344.073)">
                <path
                    id="Path_11327"
                    data-name="Path 11327"
                    d="M1721.833,714.471c3.219-11.708,5.678-29.39,15.19-37.949,1.871-1.684,9.227-.4,11.783,1.769,8.121,6.886,9.486,25.049,10.364,39.728C1755.31,719.874,1735.548,722.009,1721.833,714.471Z"
                    transform="translate(-1721.833 -675.749)"
                    fill="#79b3d1"
                />
            </g>
            <path
                id="Path_11328"
                data-name="Path 11328"
                d="M1737.023,676.548c.907-.817,3.11-.925,5.424-.583a123.753,123.753,0,0,0-6.276,24.817c-.98,7.137-1.648,13.4-2.075,17.933a42.007,42.007,0,0,1-12.264-4.219C1725.052,702.789,1727.511,685.107,1737.023,676.548Z"
                transform="translate(-1327.899 -331.703)"
                fill="#5587ba"
            />
            <path
                id="Path_11329"
                data-name="Path 11329"
                d="M1382.627,872.018c.392.3,8.391,6.38,9.869,9.477,1.514,3.175,19.307,8.939,27.825,14.05s15.71,18.55,23.455,22.525,15.159-1.325,22.541-5.679c5.155-3.04,14.633-14.461,19.892-21.087-4.213,15.3-11.96,28.669-23.3,33.012C1434.8,935.082,1385.214,891.438,1382.627,872.018Z"
                transform="translate(-1060.931 -486.147)"
                fill="#c88e7e"
            />
        </g>
    </g>,
    'Telescope',
    { width: 208, height: 181, viewBox: '0 0 417.937 366.546' }
);

export default Telescope;
